<script>
import SortableTable from "@components/SortableTable.vue";
import api from "@services/api";

export default {
  extends: SortableTable,
  name: "TarefaLista",
  page: {
    title: "Tarefas"
  },
  components: {},
  props: {
    projetoId: {
      type: Number,
      default: null
    },
    clienteId: {
      type: Number,
      default: null
    },
    contratoId:{
      type: Number, 
      default: null
    },
    filtrarTarefasAtivas:{
      type: Boolean,
      default: true
    }
  },
  data: function() {
    return {
      tarefaList: [],
      items: null,
      empty: true,
      page: 1,
      totalRows: 1,
      size: 20,
      hasItems: false,
      sort: {
        sortBy: "denominacao",
        sortOrder: "ASC"
      },
      tarefaId: undefined,
      ready: false,
      totalizador: null,
      filtroTarefaStatus: undefined,
      filtroProjetoId: undefined,
      listaCliente: [],
      tarefaStatusList: undefined
    };
  },
  watch: {
    page: function() {
      if (this.ready === true) {
        this.getTarefaList();
      }
    },
    size: function() {
      if (this.ready === true) {
        this.getTarefaList();
      }
    },
    sort: function() {
      if (this.ready === true) {
        this.getTarefaList();
      }
    },
    filtroTarefaStatus: function(val) {
      this.filtroTarefaStatus = val;
      if (this.ready === true) {
        this.getTarefaList();
      }
    },
    projetoId: function(){
      if (this.ready === true) {
        this.getTarefaList();
      }
    },
    clienteId: function(){
      if (this.ready === true) {
        this.getTarefaList();
      }
    },
    contratoId: function(){
      if (this.ready === true) {
        this.getTarefaList();
      }
    },
    filtrarTarefasAtivas: function(){
      if (this.ready === true) {
        this.getTarefaList();
      }
    }
  },
  methods: {
    getTarefaStatusList() {
      api
        .get(`api/Tarefa/TarefaStatus`)
        .then(response => (this.tarefaStatusList = response.data["data"]));
    },
    getListTarefaStatus(id) {
      if (this.user.perfil === "Administrador") {
        return this.tarefaStatusList
          ? this.tarefaStatusList.filter(
              g => g.id != id && g.denominacao != "Nova"
            )
          : [];
      }
      return [];
    },
    getTarefaList() {
      api
        .get(`api/Tarefa/ListaTarefaProjetos/${this.page}/${this.size}`, {
          params: {
            sortBy: this.sort.sortBy,
            sortOrder: this.sort.sortOrder,
            tarefaStatus: this.filtroTarefaStatus,
            projetoId: this.projetoId,
            contratoId: this.contratoId,
            clienteId: this.clienteId,
            ativo: this.filtrarTarefasAtivas
          }
        })
        .then(response => {
          this.items = response.data["data"];
          this.page = response.data["pagination"]["pageNumber"];
          this.totalRows = response.data["pagination"]["totalRecords"];
          this.hasItems = true;

          this.$store.dispatch("filter/save", [
            { type: "TarefasLista.sort", value: this.sort },
            {
              type: "TarefasLista.filtroTarefaStatus",
              value: this.filtroTarefaStatus
            },
            { type: "TarefasLista.page", value: this.page },
            { type: "TarefasLista.size", value: this.size }
          ]);
        });
      this.getTotalizador();
    },
    filtrar(filtro) {
      if (filtro == this.filtroTarefaStatus) {
        this.filtroTarefaStatus = undefined;
      } else {
        this.filtroTarefaStatus = filtro;
      }
    },
    getTotalizador() {
      api
        .get(`api/Tarefa/GetTotalizador`, {
          params: {
            projetoId: this.projetoId
          }
        })
        .then(response => {
          this.totalizador = response.data["data"];
        });
    },
    selectRow(id) {
      this.$router.push(
        this.$route.query.redirectFrom || {
          path: `/Tarefa/Edicao/${id}`
        }
      );
    },
    callNew() {
      this.$router.push(
        this.$route.query.redirectFrom || {
          path: `/Tarefa/Novo`,
          query: {
            clienteId: this.clienteId,
            projetoId: this.projetoId
          }
        }
      );
    },
    callNewExpediente(tarefaId) {
      this.$router.push(
        this.$route.query.redirectFrom || {
          path: `/Expediente/Novo`,
          query: {
            clienteId: this.clienteId,
            tarefaId: tarefaId
          }
        }
      );
    },
    callCopy(id) {
      this.$router.push(
        this.$route.query.redirectFrom || {
          path: `/Tarefa/Copiar/${id}`
        }
      );
    },
    changeTarefaStatus(tarefaId, tarefaStatusId) {
      let formData = new FormData();
      formData.append("tarefaId", tarefaId);
      formData.append("tarefaStatusId", tarefaStatusId);
      api.post(`api/Tarefa/AlterarTarefaStatus`, formData).then(() => {
        this.getTarefaList();
        this.getTotalizador();
      });
    }
  },
  created() {
    this.sort = this.filters["TarefasLista.sort"] ?? this.sort;
    this.filtroTarefaStatus = this.filters["TarefasLista.filtroTarefaStatus"];
    this.page = this.filters["TarefasLista.page"] ?? this.page;
    this.size = this.filters["TarefasLista.size"] ?? this.size;
    this.getTarefaStatusList();
    this.getTarefaList();
    this.ready = true;
  },
  computed: {
    user() {
      return this.$store.state.auth.user;
    },
    filters() {
      return this.$store.state.filter.filters;
    }
  }
};
</script>

<template>
  <div>
    <div class="text-center">
      <div class="row">
        <div class="col-md-2 col-xl-2" style="cursor: pointer">
          <div
            @click="filtrar('Nova')"
            :class="
              filtroTarefaStatus == 'Nova'
                ? 'py-1 chamado-list-selected'
                : 'py-1'
            "
          >
            <h3 class="text-secondary noselect">
              {{ totalizador  ? totalizador.novas ? totalizador.novas : 0 : "N/D" }}
            </h3>
            <p class="text-uppercase mb-1 font-13 font-weight-medium noselect">
              Novas
            </p>
          </div>
        </div>
        <div class="col-md-2 col-xl-2" style="cursor: pointer">
          <div
            @click="filtrar('Em andamento')"
            :class="
              filtroTarefaStatus == 'Em andamento'
                ? 'py-1 chamado-list-selected'
                : 'py-1'
            "
          >
            <h3 class="text-secondary noselect">
              {{ totalizador  ? totalizador.emAndamento ?  totalizador.emAndamento : 0 : "N/D" }}
            </h3>
            <p class="text-uppercase mb-1 font-13 font-weight-medium noselect">
              Em andamento
            </p>
          </div>
        </div>
        <div class="col-md-2 col-xl-2" style="cursor: pointer">
          <div
            @click="filtrar('Inativas')"
            :class="
              filtroTarefaStatus == 'Inativas'
                ? 'py-1 chamado-list-selected'
                : 'py-1'
            "
          >
            <h3 class="text-warning noselect">
              {{
                totalizador
                  ? totalizador.inativas60Dias
                    ? totalizador.inativas60Dias
                    : 0
                  : "N/D"
              }}
            </h3>
            <p class="text-uppercase mb-1 font-13 font-weight-medium noselect">
              Inativas 60 dias
            </p>
          </div>
        </div>
        <div class="col-md-2 col-xl-2" style="cursor: pointer">
          <div
            @click="filtrar('Concluída')"
            :class="
              filtroTarefaStatus == 'Concluída'
                ? 'py-1 chamado-list-selected'
                : 'py-1'
            "
          >
            <h3 class="text-primary noselect">
              {{ totalizador ? totalizador.concluidas ? totalizador.concluidas : 0 : "N/D" }}
            </h3>
            <p class="text-uppercase mb-1 font-13 font-weight-medium noselect">
              Finalizadas
            </p>
          </div>
        </div>
        <div class="col-md-2 col-xl-2" style="cursor: pointer">
          <div
            @click="filtrar('Cancelada')"
            :class="
              filtroTarefaStatus == 'Cancelada'
                ? 'py-1 chamado-list-selected'
                : 'py-1'
            "
          >
            <h3 class="text-danger noselect">
              {{ totalizador ? totalizador.canceladas ? totalizador.canceladas : 0 : "N/D" }}
            </h3>
            <p class="text-uppercase mb-1 font-13 font-weight-medium noselect">
              Canceladas
            </p>
          </div>
        </div>
        <div class="col-xl mt-3" style="text-align: right">
          <b-button
            class="btn"
            variant="primary"
            v-on:click="callNew()"
            v-if="user.perfil === 'Administrador'"
          >
            Nova tarefa
          </b-button>
        </div>
      </div>
    </div>

    <div class="row mt-2 mb-2" v-show="!hasItems">
      <div class="col-md-12">Não foram encontrados registros.</div>
    </div>
    <div class="table-sm table mt-2 " v-show="hasItems">
      <table class="table b-table table table-hover">
        <thead class="thead-primary">
          <tr>
            <th
              class="columnheader"
              scope="col"
              @click="changeSort(null, 'cliente', true)"
              v-if="projetoId == null"
            >
              Cliente
              <i
                class="fas fa-sort-down ml-2"
                v-show="showSortDown(null, 'cliente', true)"
              />
              <i
                class="fas fa-sort-up ml-2"
                v-show="showSortUp(null, 'cliente', true)"
              />
              <i
                class="fas fa-sort ml-2"
                style="color: lightgray"
                v-show="showSortNone(null, 'cliente', true)"
              />
            </th>
             <th
              class="columnheader"
              scope="col"
              @click="changeSort(null, 'cliente', true)"
              v-if="projetoId == null"
            >
              Projeto
              <i
                class="fas fa-sort-down ml-2"
                v-show="showSortDown(null, 'cliente', true)"
              />
              <i
                class="fas fa-sort-up ml-2"
                v-show="showSortUp(null, 'projeto', true)"
              />
              <i
                class="fas fa-sort ml-2"
                style="color: lightgray"
                v-show="showSortNone(null, 'cliente', true)"
              />
            </th>
            <th
              class="columnheader"
              scope="col"
              @click="changeSort(null, 'denominacao', true)"
            >
              Tarefa
              <i
                class="fas fa-sort-down ml-2"
                v-show="showSortDown(null, 'denominacao', true)"
              />
              <i
                class="fas fa-sort-up ml-2"
                v-show="showSortUp(null, 'denominacao', true)"
              />
              <i
                class="fas fa-sort ml-2"
                style="color: lightgray"
                v-show="showSortNone(null, 'denominacao', true)"
              />
            </th>
            <th
              class="columnheader"
              scope="col"
              style="min-width: 100px"
              @click="changeSort(null, 'tarefaStatus', true)"
            >
              Status
              <i
                class="fas fa-sort-down ml-2"
                v-show="showSortDown(null, 'tarefaStatus', true)"
              />
              <i
                class="fas fa-sort-up ml-2"
                v-show="showSortUp(null, 'tarefaStatus', true)"
              />
              <i
                class="fas fa-sort ml-2"
                style="color: lightgray"
                v-show="showSortNone(null, 'tarefaStatus', true)"
              />
            </th>
            <th class="columnheader" scope="col" style="min-width: 100px">
              Andamento
            </th>
            <th
              class="columnheader"
              scope="col"
              style="width: 110px"
              @click="changeSort(null, 'percentualConclusao', true)"
            >
              Conclusão
              <i
                class="fas fa-sort-down ml-2"
                v-show="showSortDown(null, 'percentualConclusao', true)"
              />
              <i
                class="fas fa-sort-up ml-2"
                v-show="showSortUp(null, 'percentualConclusao', true)"
              />
              <i
                class="fas fa-sort ml-2"
                style="color: lightgray"
                v-show="showSortNone(null, 'percentualConclusao', true)"
              />
            </th>
            <th
              class="columnheader"
              scope="col"
              style="min-width: 130px"
              @click="changeSort(null, 'responsavel', true)"
            >
              Responsável
              <i
                class="fas fa-sort-down ml-2"
                v-show="showSortDown(null, 'responsavel', true)"
              />
              <i
                class="fas fa-sort-up ml-2"
                v-show="showSortUp(null, 'responsavel', true)"
              />
              <i
                class="fas fa-sort ml-2"
                style="color: lightgray"
                v-show="showSortNone(null, 'responsavel', true)"
              />
            </th>
            <th class="columnheader" scope="col" style="width: 150px">
              Data últ. expediente
            </th>
            <th
              class="columnheader"
              scope="col"
              style="width: 50px"
              v-if="
                user.perfil === 'Administrador' || user.perfil === 'Consultor'
              "
            >
              Ações
            </th>
          </tr>
        </thead>
        <tbody class="selected-table">
          <tr
            v-for="item in items"
            :key="item.id"
            :class="
              `${
                item.chRealizado > item.chPrevisto
                  ? 'danger'
                  : item.chRealizado > item.chPrevisto * 0.7
                  ? 'warning'
                  : ''
              }`
            "
          >
            <td scope="row" @click="selectRow(item.id)" v-if="projetoId == null">
              {{ item.cliente }}
            </td>
             <td scope="row" @click="selectRow(item.id)">
              {{ item.projeto }}
            </td>
            <td scope="row" @click="selectRow(item.id)">
              {{ item.denominacao }}
            </td>
            <td scope="row" @click="selectRow(item.id)">
              {{ item.tarefaStatus }}
            </td>
            <td scope="row" @click="selectRow(item.id)">
              {{ item.chRealizado }}h de {{ item.chPrevisto }}h
            </td>
            <td scope="row" @click="selectRow(item.id)">
              {{ item.percentualConclusao }}%
            </td>
            <td scope="row" @click="selectRow(item.id)">
              {{ item.responsavel }}
            </td>
            <td class="text-center" scope="row" @click="selectRow(item.id)">
              {{ item.ultimoExpediente | formatField("datetime") }}
            </td>
            <td
              width="60px;"
              v-if="
                user.perfil === 'Administrador' || user.perfil === 'Consultor'
              "
            >
              <b-dropdown variant="primary" text="..." size="sm" dropleft>
                <b-dropdown-item @click="selectRow(item.id)">
                  Visualizar
                </b-dropdown-item>
                <b-dropdown-item @click="callNewExpediente(item.id)">
                  Cadastrar Expediente
                </b-dropdown-item>
                <!-- tarefaStatusList -->
                <b-dropdown-divider></b-dropdown-divider>
                <b-dropdown-item
                  @click="callCopy(item.id)"
                  v-if="user.perfil === 'Administrador'"
                >
                  Copiar
                </b-dropdown-item>
                <b-dropdown-item
                  @click="changeTarefaStatus(item.id, option.id)"
                  v-for="option in getListTarefaStatus(item.tarefaStatusId)"
                  :key="option.id"
                  :value="option.id"
                >
                  {{ option.denominacao }}
                </b-dropdown-item>
              </b-dropdown>
            </td>
          </tr>
        </tbody>
      </table>
      <div class="row" v-show="totalRows > 10">
        <div class="col-md-9 mt-1">
          <b-pagination
            v-model="page"
            pills
            :total-rows="totalRows"
            :per-page="size"
          />
        </div>
        <div class="col-md-3">
          <b-form-group
            id="size"
            label-cols-lg="7"
            label="Registros por página:"
          >
            <b-form-select v-model="size">
              <b-form-select-option value="10">10</b-form-select-option>
              <b-form-select-option value="20">20</b-form-select-option>
              <b-form-select-option value="50">50</b-form-select-option>
              <b-form-select-option value="100">100</b-form-select-option>
            </b-form-select>
          </b-form-group>
        </div>
      </div>
    </div>
  </div>
</template>

<style scoped>
.noselect {
  -webkit-touch-callout: none;
  -webkit-user-select: none;
  -khtml-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
}
</style>
